import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import { PERMISSION_ACTIONS, PERMISSION_VERBS } from '~/components/core';
import { useHasPermission } from '~/components/hooks/useHasPermission';

import ConfigurationScreenWithTabs from '../ConfigurationScreenWithTabs';

import SorConfigurationTab from './SorConfigurationTab';
import SorIssuesTab from './SorIssuesTab';
import TEXTS from './texts';

export const SYSTEM_OF_RECORD_SUBTITLE =
  "Commit claim actions at the organization's external System of Record, and test the connection to it.";

interface SystemOfRecordProps {
  /** Five Sigma's internal admin: the configuration is saved there and nowhere else, and both tabs are open, the server
   * deciding. Elsewhere the configuration is read-only. */
  isInternal?: boolean;
}

// Each tab under its own permission, as the server gates its routes: an operator who resolves attempts need not be
// allowed the configuration, nor the reverse.
const SystemOfRecord: React.FC<SystemOfRecordProps> = ({ isInternal = false }) => {
  const match = useRouteMatch();
  const hasConfigurationScope = useHasPermission({
    action: PERMISSION_ACTIONS.SYSCONFIG_SYSTEM_OF_RECORD,
    verb: PERMISSION_VERBS.READ,
  });
  const hasIssuesScope = useHasPermission({
    action: PERMISSION_ACTIONS.SOR_ISSUES_MANAGE,
    verb: PERMISSION_VERBS.READ,
  });
  const canReadConfiguration = isInternal || hasConfigurationScope;
  const canReadIssues = isInternal || hasIssuesScope;
  const tabs = [
    {
      label: TEXTS.tabs.configuration,
      url: 'configuration',
      component: SorConfigurationTab,
      props: { issuesUrl: canReadIssues ? `${match.url}/issues` : undefined, isInternal },
      isEnabled: canReadConfiguration,
    },
    { label: TEXTS.tabs.issues, url: 'issues', component: SorIssuesTab, isEnabled: canReadIssues },
  ];

  return (
    <ConfigurationScreenWithTabs
      tabs={tabs}
      title={TEXTS.systemOfRecord}
      subtitle={SYSTEM_OF_RECORD_SUBTITLE}
      operationTabName={TEXTS.systemOfRecord}
    />
  );
};

export default SystemOfRecord;
